import React from 'react'
import listOfSalary from './daten-loehne.csv'
import chroma from 'chroma-js'
import IntlMessageFormat from 'intl-messageformat'
import { MiniVoting } from '../miniVoting'
import { Waypoint } from 'react-waypoint'
import './styles.scss'

const isMobile = window.innerWidth < 340

function SalaryList(props) {
  const sortedSalary = listOfSalary.sort(
    (a, b) => parseInt(a.Monatslohn) - parseInt(b.Monatslohn)
  )

  // chroma scale Color
  const colorScale = chroma
    .scale(['#64b9e8', 'a6e8a6', '#fee090', '#ea7f7f', 'b39ddb'])
    .mode('rgb')
    .domain([500, props.sliderValue, props.sliderValue + 1, 20000, 1500000])

  let checkBetween = false

  // Funktion Zahl Tausendertrennzeichen mit '
  const digitFormat = new Intl.NumberFormat('de-CH', {
    style: 'decimal',
    minimumFractionDigits: 0
  }).format

  // maping through sortedSalary
  return sortedSalary.map((item, index) => {
    const allDays = Math.ceil(
      parseInt(item.Monatslohn) / (props.sliderValue / 22)
    )

    // calculate number of days months and years you have working for the salary from others
    const nYears = Math.trunc(allDays / 250)
    const nMonths = Math.trunc((allDays % 250) / 22)
    const nDays = (allDays % 250) % 22

    // checking date (day, month, year) if its 0, display or not
    let checkMonthsNull = false
    let checkYearsNull = false
    const checkIndexOne = index === 1

    if (nYears !== 0 || nMonths !== 0) {
      checkMonthsNull = true
    }
    if (nYears !== 0) {
      checkYearsNull = true
    }

    // check if user month salary is between -> true insert user salary in list, after insert set variable back to false
    if (sortedSalary[index - 1]) {
      if (
        item.Monatslohn >= props.sliderValue + 1 &&
        sortedSalary[index - 1].Monatslohn < props.sliderValue + 1
      ) {
        checkBetween = true
      } else {
        checkBetween = false
      }
    }

    // Check if Date is singular

    const MESSAGES = {
      NUM_DAYS:
        '{numDays, plural, ' + '=0 {Tage}' + '=1 {Tag}' + 'other {Tage}}',

      NUM_MONTHS:
        '{numMonths, plural, ' +
        '=0 {Monate}' +
        '=1 {Monat}' +
        'other {Monate}}',

      NUM_YEARS:
        '{numYears, plural, ' + '=0 {Jahre}' + '=1 {Jahr}' + 'other {Jahre}}'
    }

    const deNumDays = new IntlMessageFormat(MESSAGES.NUM_DAYS, 'de-CH')
    const deNumMonths = new IntlMessageFormat(MESSAGES.NUM_MONTHS, 'de-CH')
    const deNumYears = new IntlMessageFormat(MESSAGES.NUM_YEARS, 'de-CH')

    // As variable for mutliple uses: const outputDays = deNumDays.format({ numDays: nDays })

    return (
      <div key={'_' + index}>
        {checkBetween && item.Monatslohn >= props.sliderValue && (
          <div>
            <div className='ui horizontal divider yourSalaryWrapper'>
              <div className='innerWrapper'>
                <img
                  src={require('../imgs/icon-user-salary.svg')}
                  className='yourSalaryIcon'
                  alt='yourSalary Icon'
                />
                {/* <i className='user icon small black' /> */}
                <div className='yourSalaryInfo'>
                  <div className='boldSalaryInfo'>Ihr Monatsgehalt</div>
                  <div>{digitFormat(props.sliderValue)} Fr.</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {item.Kategorie.toLowerCase().indexOf('category') !== -1 && (
          <div>
            <div className='salaryRangeBox'>
              <div className='salaryRangeTitle'>{item.Beruf}</div>
            </div>
          </div>
        )}

        {item.Kategorie.toLowerCase().indexOf('item') !== -1 && (
          <div
            className='listItem'
            style={{ backgroundColor: colorScale(item.Monatslohn) }}
          >
            <Waypoint
              scrollableAncestor={window}
              onEnter={event => {
                if (event.previousPosition === Waypoint.below) {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: 'Interactions',
                    event_action: 'vertical-scroll',
                    event_label: (index + 1) * 2.25 + ' ContentRead'
                  })
                }
              }}
            />

            <div className='itemRow'>
              <div className='itemInfo'>
                {/* <div className='itemTimeIcon'>
                <img
                  src={require(`../imgs/${item.Icon}`)}
                  className='iconWorkHours'
                />
              </div> */}
                <div>
                  <div
                    className='itemJob'
                    dangerouslySetInnerHTML={{ __html: item.Beruf }}
                  />
                  <div
                    className={
                      checkIndexOne
                        ? 'itemSalary firstElement'
                        : 'itemSalary firstElement'
                    }
                  >
                    <div>
                      {digitFormat(item.Monatslohn)}&nbsp;Fr.{' '}
                      {checkIndexOne && (
                        <span
                          className='itemBylineText'
                          style={{ color: 'black' }}
                        >
                          brutto für 100%, pro&nbsp;Monat
                        </span>
                      )}
                      {!checkIndexOne &&
                        (isMobile ? (
                          <span
                            className='itemBylineText'
                            style={{ color: 'black' }}
                          >
                            pro&nbsp;Mt.
                          </span>
                        ) : (
                          <span
                            className='itemBylineText'
                            style={{ color: 'black' }}
                          >
                            pro&nbsp;Monat
                          </span>
                        ))}
                    </div>
                    {/* {checkIndexOne && (
                  <div className='ui left pointing label'>
                    brutto für 100%, pro Monat
                  </div>
                )} */}
                  </div>
                </div>
              </div>

              <div className='itemTime'>
                <div className='itemTimeClock'>
                  <div className='itemTimeIcon'>
                    <img
                      src={require('../imgs/icon_workhours.svg')}
                      className='iconWorkHours'
                    />
                  </div>

                  {checkYearsNull && (
                    <div className='itemTimeYears'>
                      {nYears}
                      <div>{deNumYears.format({ numYears: nYears })}</div>
                    </div>
                  )}

                  {checkMonthsNull && (
                    <div className='itemTimeMonths'>
                      {nMonths}
                      <div>{deNumMonths.format({ numMonths: nMonths })}</div>
                    </div>
                  )}

                  <div className='itemTimeDays'>
                    {nDays}
                    <br />
                    <div>{deNumDays.format({ numDays: nDays })}</div>
                  </div>
                </div>

                {/* {allDays} */}
              </div>
            </div>

            <div className='bylineWrapper'>
              <div className='itemByline'>
                <div
                  dangerouslySetInnerHTML={{ __html: item.Bemerkung }}
                  className='itemBylineText'
                />
                {/* <div className='itemBylineText'>{item.Bemerkung}</div> */}
              </div>
              {checkIndexOne && (
                <div className='ui pointing label intro'>
                  Mit Ihrem Gehalt haben Sie nach{' '}
                  {nDays === 1 && nMonths === 0 && (
                    <span>einem Arbeitstag</span>
                  )}
                  {nMonths !== 0 && (
                    <span>
                      {nMonths >= 1 && nDays === 0 && <span>einem Monat</span>}
                      {nMonths >= 1 && nDays === 1 && (
                        <span>einem Monat und einem Tag</span>
                      )}
                      {nMonths >= 1 && nDays > 1 && (
                        <span>einem Monat und {nDays}&nbsp;Tagen</span>
                      )}
                    </span>
                  )}
                  {nMonths === 0 && nDays > 1 && (
                    <span>
                      {nDays > 1 && nMonths === 0 ? (
                        <span>{nDays}&nbsp;Arbeitstagen</span>
                      ) : (
                        <span>{nDays}&nbsp;Arbeitstag</span>
                      )}
                    </span>
                  )}{' '}
                  den Monats&shy;lohn eines Kita-Praktikanten erreicht.
                </div>
              )}
            </div>

            <MiniVoting
              articleID={props.articleId}
              elementId={index + '_' + item.Beruf.replace(/[^a-z0-9+]+/gi, '+')}
              subject='Lohnrechner'
            />
          </div>
        )}
      </div>
    )
  })
}

export { SalaryList }
